let setTimer = null;
let loader;

function fetchProducts(lang) {
  const selectArea = document.getElementById('select-area');
  const selectMaterial = document.getElementById('select-material');
  const selectApplication = document.getElementById('select-application');
  const viewButtons = document.querySelector('.btn-group-toggle').children;
  const filterCat = document.getElementById('filter-solutions').dataset.cat;
  let viewVal;
  Array.from(viewButtons).forEach((el) => {
    if (el.classList.contains('active')) {
      viewVal = el.querySelector('input').value;
    }
  });
  const area = (selectArea.value) ? selectArea.value : 0;
  const material = (selectMaterial.value) ? selectMaterial.value : 0;
  const application = (selectApplication.value) ? selectApplication.value : 0;
  const productsEl = document.getElementById('display-products');
  productsEl.innerHTML = '';
  loader.classList.remove('d-none');

  const endpoint = `/wp-json/api/fetch/filter/products/?area=${area}&material=${material}&app=${application}&view=${viewVal}&default=${filterCat}&lang=${lang}`;
  fetch(endpoint)
    .then((response) => response.json())
    .then((object) => {
      if (object) {
        productsEl.innerHTML = object;
      }
      loader.classList.add('d-none');
    })
    .catch((error) => {
      console.log(error);
      // loader.classList.add('d-none');
    });
}

function process(lang)
{
  clearTimeout(setTimer);
  setTimer = setTimeout(() => {
    fetchProducts(lang);
  }, 500);
}

export default {
  init() {
    console.log('init prodts')
    const loaderEl = document.getElementById('bewi-loader');
    loader = (loaderEl) ? loaderEl : null;
    const filterCat = document.getElementById('filter-solutions');
    if (filterCat) {
      const lang = filterCat.dataset.lang;
      const selectArea = document.getElementById('select-area');
      const selectMaterial = document.getElementById('select-material');
      const selectApplication = document.getElementById('select-application');
      let filterObject;
      const categoryTermId = (selectArea.hasAttribute('data-category')) ? selectArea.dataset.category : false;
      const cat = filterCat.dataset.cat;
      const endpoint = '/wp-json/api/fetch/filters/?c=' + cat + '&lang=' + lang;
      fetch(endpoint)
        .then((response) => response.json())
        .then((items) => {
          if (items) {
            filterObject = items.categories;
            for (const [key] of Object.entries(items.categories)) {
              const option = document.createElement('option');
              option.innerHTML = items.categories[key].name;
              option.setAttribute('value', items.categories[key].term_id);
              if (categoryTermId && categoryTermId == items.categories[key].term_id) {
                option.setAttribute('selected', 'selected');
                if (items.categories[key].children) {
                  items.categories[key].children.forEach((item) => {
                    const option = document.createElement('option');
                    option.innerHTML = item.name;
                    option.setAttribute('value', item.term_id);
                    selectMaterial.appendChild(option);
                  });
                  selectMaterial.removeAttribute('disabled');
                }
                if (items.categories[key].tags) {
                  const tags = items.categories[key].tags;
                  for (const [key] of Object.entries(tags)) {
                    const option = document.createElement('option');
                    option.innerHTML = tags[key].name;
                    option.setAttribute('value', key);
                    selectApplication.appendChild(option);
                  }
                  selectApplication.removeAttribute('disabled');
                }
              } else {
                for (const area in filterObject) {
                  if (items.categories[area].children) {
                    items.categories[area].children.forEach((item) => {
                      const option = document.createElement('option');
                      option.innerHTML = item.name;
                      option.setAttribute('value', item.term_id);
                      if (
                        !selectMaterial.querySelector(
                          `option[value="${item.term_id}"]`
                        )
                      ) {
                        selectMaterial.appendChild(option);
                      }
                    });
                  }
                  if (filterObject[area].tags) {
                    const tags = filterObject[area].tags;
                    for (const [key] of Object.entries(tags)) {
                      const option = document.createElement('option');
                      option.innerHTML = tags[key].name;
                      option.setAttribute('value', key);
                      if (
                        !selectApplication.querySelector(
                          `option[value="${key}"]`
                        )
                      ) {
                        selectApplication.appendChild(option);
                      }
                    }
                    
                  }
                }
                selectMaterial.removeAttribute('disabled');
                selectApplication.removeAttribute('disabled');
              }
              selectArea.appendChild(option);
            }
            // items.tags.forEach((tag) => {
            //   const option = document.createElement('option');
            //   option.innerHTML = tag.name;
            //   option.setAttribute('value', tag.term_id);
            //   selectApplication.appendChild(option);
            // });
          }
        })
        .catch((error) => {
          console.log(error);
        });

      let selectedArea;
      selectArea.addEventListener('change', (event) => {
        selectedArea = event.currentTarget.value;
        const firstMaterialChild = selectMaterial.firstElementChild;
        selectMaterial.innerHTML = '';
        selectMaterial.append(firstMaterialChild);
        if(selectedArea !== '0') {
          if (filterObject[selectedArea].children) {
            filterObject[selectedArea].children.forEach((item) => {
              const option = document.createElement('option');
              option.innerHTML = item.name;
              option.setAttribute('value', item.term_id);
              selectMaterial.appendChild(option);
            });
            selectMaterial.removeAttribute('disabled');
          } else {
            selectMaterial.setAttribute('disabled', 'disabled');
          }
        }

        const firstApplicationChild = selectApplication.firstElementChild;
        selectApplication.innerHTML = '';
        selectApplication.append(firstApplicationChild);

        if(selectedArea !== '0') {
          if (filterObject[selectedArea].tags) {
            const tags = filterObject[selectedArea].tags;
            for (const [key] of Object.entries(tags)) {
              const option = document.createElement('option');
              option.innerHTML = tags[key].name;
              option.setAttribute('value', key);
              selectApplication.appendChild(option);
            }
            selectApplication.removeAttribute('disabled');
          } else {
            selectApplication.setAttribute('disabled', 'disabled');
          }
        }
        
        if(selectedArea == 0){
          for (const area in filterObject) {
            if (filterObject[area].children) {
              filterObject[area].children.forEach((item) => {
                const option = document.createElement('option');
                option.innerHTML = item.name;
                option.setAttribute('value', item.term_id);
                if (
                  !selectMaterial.querySelector(
                    `option[value="${item.term_id}"]`
                  )
                ) {
                  selectMaterial.appendChild(option);
                }
              });
            }
            if (filterObject[area].tags) {
              const tags = filterObject[area].tags;
              for (const [key] of Object.entries(tags)) {
                const option = document.createElement('option');
                option.innerHTML = tags[key].name;
                option.setAttribute('value', key);
                if (
                  !selectApplication.querySelector(`option[value="${key}"]`)
                ) {
                  selectApplication.appendChild(option);
                }
              }
            }
          }
          selectMaterial.removeAttribute('disabled');
          selectApplication.removeAttribute('disabled');
        }
        event.preventDefault();
        process(lang);
      });

      selectMaterial.addEventListener('change', (e) => {
        e.preventDefault();
        process(lang);
      });
      selectApplication.addEventListener('change', (e) => {
        e.preventDefault();
        process(lang);
      });
      const viewTrigger = document.querySelector('.btn-group-toggle').children;
      Array.from(viewTrigger).forEach((el) => {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          process(lang);
        });
      });
      $('body').on('click', '.show-all', function (el) {
          const elements = el.currentTarget.parentNode.children;
          Array.from(elements).forEach((element) =>{
            element.classList.add('d-flex')
          });
          el.currentTarget.classList.replace('d-flex', 'd-none');
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/products.js